<template>
  <div v-title="$route.name">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="updated_at"
                         label="更新时间"
                         min-width="90"></el-table-column>
        <el-table-column prop="admin_name"
                         label="操作人"
                         min-width="120"></el-table-column>
        <el-table-column prop="received_amount"
                         label="回款金额"
                         min-width="120"></el-table-column>
        <el-table-column prop="received_payment_time"
                         label="回款时间"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="desc"
                         label="备注"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="操作"
                         min-width="90">
          <template slot-scope="scope">
            <el-button type="primary" @click="onDownload(scope.row)" size="small">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    </div>
</template>

<script>
import { searchRules } from '../invoice-apply.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  components: {
  },
  data () {
    return {
      searchRules,
      search: {
        received_payment_status: null,
        customerid: null,
        projectid: null,
        bu_approver: null,
        created_at: [],
        received_payment_time: [],
      },
      selectLoading: false,
      customerItems: [],
      projectItems: [],
      adminuserItems: [],
      visible: false,
      dialogType: null,
      currentId: null,
    }
  },
  computed: {
    ...Vuex.mapState({
    }),
  },
  created () {},
  methods: {
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params.id = this.$route.params.id
      return request.page('getReceivedPaymentLogTable', params)
    },
    onDownload (row) {
      window.open(row.attached_file)
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/ReceivedPaymentLogTable.vue